export const FEEDBACK_WIDGET_STEPS = ['rating', 'feedback', 'userTesting'] as const
export type FeedbackWidgetStep = (typeof FEEDBACK_WIDGET_STEPS)[number]

export const FEEDBACK_WIDGETS_DISMISSED_STORAGE_KEY = 'feedback_widgets_dismissed'
export const FEEDBACK_WIDGETS_DISMISSED_DAYS = 30
export const LEGACY_FEEDBACK_WIDGET_COOKIE_PREFIX = 'FeedbackWidget-'
